import parse from "html-react-parser"
import styles from "./header.module.scss"

interface Props {
  logo: string
  onBackClick: () => void
}

import chevronLeftBlack from "images/layout/chevron-left-black.svg?raw"

const Header = ({ logo, onBackClick }: Props) => {
  return (
    <header className={styles.cancelling_billing}>
      <div className={styles.spacer}>
        {onBackClick && (
          <button
            type="submit"
            className="button-tertiary button-outlined button-with-icon only-icon-on-mobile"
            aria-label="Back button"
            onClick={onBackClick}
          >
            <span className="button-icon">
              {parse(chevronLeftBlack)}
            </span>
            <span className="hide-on-xs">Back</span>
          </button>
        )}
      </div>
      <span className={styles["ifttt-logo"]}>
        <img src={logo} alt="IFTTT logo" />
      </span>
      <div className={styles.spacer} />
    </header>
  )
}

export default Header
